import {useCurrentRepository} from '@github-ui/current-repository'
import {branchPath, pullRequestPath} from '@github-ui/paths'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {GitBranchIcon} from '@primer/octicons-react'
import {Box, BranchName, Link, Octicon} from '@primer/react'
import React from 'react'
import type {BranchCommitState} from '../../hooks/use-load-branch-commits'

export interface CommitBranchInfoProps {
  data: BranchCommitState
}

export function CommitBranchInfo({data}: CommitBranchInfoProps) {
  const repo = useCurrentRepository()

  if (!data.loading && data.branches.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        color: 'fg.subtle',
        borderBottomStyle: 'solid',
        borderColor: 'border.default',
        borderWidth: '1px',
        p: 3,
      }}
    >
      <Octicon icon={GitBranchIcon} sx={{mr: 2}} />
      {data.loading ? (
        <LoadingSkeleton width="60px" variant="rounded" height="22px" />
      ) : (
        data.branches.map(branch => {
          return (
            <React.Fragment key={branch.branch}>
              <BranchName
                href={branchPath({owner: repo.ownerLogin, repo: repo.name, branch: branch.branch})}
                sx={{mx: 1}}
              >
                {branch.branch}
              </BranchName>
              {branch.prs.length > 0 ? (
                <>
                  {'('}
                  {branch.prs.map((pr, index) => (
                    <React.Fragment key={`pr-${pr}`}>
                      <Link href={pullRequestPath({repo, number: pr})} sx={{color: 'fg.subtle'}}>
                        #{pr}
                      </Link>
                      {index !== branch.prs.length - 1 ? <>,&nbsp;</> : null}
                    </React.Fragment>
                  ))}
                  {')'}
                </>
              ) : null}
            </React.Fragment>
          )
        })
      )}
    </Box>
  )
}

try{ CommitBranchInfo.displayName ||= 'CommitBranchInfo' } catch {}